export default __webpack_public_path__ + "static/P_SearchThumb_Microphones-0ca5f7e3bf2a4c3ba1aa6bb117efa403.webp";